import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, {
  parseFractionLikeInput as parseFraction,
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

const DEC_TOL = 0.01;
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function generateTask() {
  const A = Array.from({ length: 18 }, (_, i) => i + 3); // 3..20
  const a = pick(A), b = pick(A);
  return { type: "RectanglePerimeterFromSidesTask", data: { a, b, Ob: 2 * (a + b) } };
}

export function renderTask({ data }) {
  const { a, b } = data;
  return (
    <div style={{ marginTop: 8 }}>
      Dany jest prostokąt o bokach <InlineMath math={`a=${a}`} /> i <InlineMath math={`b=${b}`} />.
      Oblicz jego obwód <InlineMath math={"Ob"} />.
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  const normalize = (v) => (typeof v === "string" ? v : v?.raw ?? "");
  return (
    <FractionInput
      value={raw}
      onChange={(v) => onChange({ raw: normalize(v) })}
      disabled={disabled}
      label="Ob"
      placeholder="np. 46"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return false;
  const val = parseFraction(raw);
  return Number.isFinite(val) && Math.abs(val - data.Ob) <= DEC_TOL;
}

export const renderAnswer = ({ data }) => <InlineMath math={`Ob=${data.Ob}`} />;

export function renderExplanation({ data }) {
  const { a, b, Ob } = data;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <strong>Krok 1.</strong> Wzór na obwód prostokąta: <InlineMath math={"Ob=2(a+b)"} />.
      <BlockMath math={`Ob=2\\,( ${a}+${b} )`} />
      <BlockMath math={`Ob=2\\cdot ${a+b}=${Ob}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(raw, "Ob")} />;
}

export default {
  generateTask,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};
